///leadtype/list
export const LEAD_TYPE_LIST = "LEAD_TYPE_LIST";
export const LEAD_TYPE_LIST_SUCCESS = "LEAD_TYPE_LIST_SUCCESS";
export const LEAD_TYPE_LIST_FAILURE = "LEAD_TYPE_LIST_FAILURE";
///leadtype/data
export const LEAD_TYPE_DATA = "LEAD_TYPE_DATA";
export const LEAD_TYPE_DATA_SUCCESS = "LEAD_TYPE_DATA_SUCCESS";
export const LEAD_TYPE_DATA_FAILURE = "LEAD_TYPE_DATA_FAILURE";
///leadtype/create
export const LEAD_TYPE_CREATE = "LEAD_TYPE_CREATE";
export const LEAD_TYPE_CREATE_SUCCESS = "LEAD_TYPE_CREATE_SUCCESS";
export const LEAD_TYPE_CREATE_FAILURE = "LEAD_TYPE_CREATE_FAILURE";
///leadtype/update
export const LEAD_TYPE_UPDATE = "LEAD_TYPE_UPDATE";
export const LEAD_TYPE_UPDATE_SUCCESS = "LEAD_TYPE_UPDATE_SUCCESS";
export const LEAD_TYPE_UPDATE_FAILURE = "LEAD_TYPE_UPDATE_FAILURE";
///leadtype/delete
export const LEAD_TYPE_DELETE = "LEAD_TYPE_DELETE";
export const LEAD_TYPE_DELETE_SUCCESS = "LEAD_TYPE_DELETE_SUCCESS";
export const LEAD_TYPE_DELETE_FAILURE = "LEAD_TYPE_DELETE_FAILURE";

///leadstatus/list
export const LEAD_STATUS_LIST = "LEAD_STATUS_LIST";
export const LEAD_STATUS_LIST_SUCCESS = "LEAD_STATUS_LIST_SUCCESS";
export const LEAD_STATUS_LIST_FAILURE = "LEAD_STATUS_LIST_FAILURE";
///leadstatus/data
export const LEAD_STATUS_DATA = "LEAD_STATUS_DATA";
export const LEAD_STATUS_DATA_SUCCESS = "LEAD_STATUS_DATA_SUCCESS";
export const LEAD_STATUS_DATA_FAILURE = "LEAD_STATUS_DATA_FAILURE";
///leadstatus/create
export const LEAD_STATUS_CREATE = "LEAD_STATUS_CREATE";
export const LEAD_STATUS_CREATE_SUCCESS = "LEAD_STATUS_CREATE_SUCCESS";
export const LEAD_STATUS_CREATE_FAILURE = "LEAD_STATUS_CREATE_FAILURE";
///leadstatus/update
export const LEAD_STATUS_UPDATE = "LEAD_STATUS_UPDATE";
export const LEAD_STATUS_UPDATE_SUCCESS = "LEAD_STATUS_UPDATE_SUCCESS";
export const LEAD_STATUS_UPDATE_FAILURE = "LEAD_STATUS_UPDATE_FAILURE";
///leadstatus/delete
export const LEAD_STATUS_DELETE = "LEAD_STATUS_DELETE";
export const LEAD_STATUS_DELETE_SUCCESS = "LEAD_STATUS_DELETE_SUCCESS";
export const LEAD_STATUS_DELETE_FAILURE = "LEAD_STATUS_DELETE_FAILURE";

///leadpriority/list
export const LEAD_PRIORITY_LIST = "LEAD_PRIORITY_LIST";
export const LEAD_PRIORITY_LIST_SUCCESS = "LEAD_PRIORITY_LIST_SUCCESS";
export const LEAD_PRIORITY_LIST_FAILURE = "LEAD_PRIORITY_LIST_FAILURE";
///leadpriority/data
export const LEAD_PRIORITY_DATA = "LEAD_PRIORITY_DATA";
export const LEAD_PRIORITY_DATA_SUCCESS = "LEAD_PRIORITY_DATA_SUCCESS";
export const LEAD_PRIORITY_DATA_FAILURE = "LEAD_PRIORITY_DATA_FAILURE";
///leadpriority/create
export const LEAD_PRIORITY_CREATE = "LEAD_PRIORITY_CREATE";
export const LEAD_PRIORITY_CREATE_SUCCESS = "LEAD_PRIORITY_CREATE_SUCCESS";
export const LEAD_PRIORITY_CREATE_FAILURE = "LEAD_PRIORITY_CREATE_FAILURE";
///leadpriority/update
export const LEAD_PRIORITY_UPDATE = "LEAD_PRIORITY_UPDATE";
export const LEAD_PRIORITY_UPDATE_SUCCESS = "LEAD_PRIORITY_UPDATE_SUCCESS";
export const LEAD_PRIORITY_UPDATE_FAILURE = "LEAD_PRIORITY_UPDATE_FAILURE";
///leadpriority/delete
export const LEAD_PRIORITY_DELETE = "LEAD_PRIORITY_DELETE";
export const LEAD_PRIORITY_DELETE_SUCCESS = "LEAD_PRIORITY_DELETE_SUCCESS";
export const LEAD_PRIORITY_DELETE_FAILURE = "LEAD_PRIORITY_DELETE_FAILURE";

///leadnote/list
export const LEAD_NOTE_LIST = "LEAD_NOTE_LIST";
export const LEAD_NOTE_LIST_SUCCESS = "LEAD_NOTE_LIST_SUCCESS";
export const LEAD_NOTE_LIST_FAILURE = "LEAD_NOTE_LIST_FAILURE";
///leadnote/search
export const LEAD_NOTE_SEARCH = "LEAD_NOTE_SEARCH";
export const LEAD_NOTE_SEARCH_SUCCESS = "LEAD_NOTE_SEARCH_SUCCESS";
export const LEAD_NOTE_SEARCH_FAILURE = "LEAD_NOTE_SEARCH_FAILURE";
///leadnote/data
export const LEAD_NOTE_DATA = "LEAD_NOTE_DATA";
export const LEAD_NOTE_DATA_SUCCESS = "LEAD_NOTE_DATA_SUCCESS";
export const LEAD_NOTE_DATA_FAILURE = "LEAD_NOTE_DATA_FAILURE";
///leadnote/create
export const LEAD_NOTE_CREATE = "LEAD_NOTE_CREATE";
export const LEAD_NOTE_CREATE_SUCCESS = "LEAD_NOTE_CREATE_SUCCESS";
export const LEAD_NOTE_CREATE_FAILURE = "LEAD_NOTE_CREATE_FAILURE";

///lead/list
export const LEAD_LIST = "LEAD_LIST";
export const LEAD_LIST_SUCCESS = "LEAD_LIST_SUCCESS";
export const LEAD_LIST_FAILURE = "LEAD_LIST_FAILURE";
///lead/list_uninvoiced
export const LEAD_LIST_UNINVOICED = "LEAD_LIST_UNINVOICED";
export const LEAD_LIST_UNINVOICED_SUCCESS = "LEAD_LIST_UNINVOICED_SUCCESS";
export const LEAD_LIST_UNINVOICED_FAILURE = "LEAD_LIST_UNINVOICED_FAILURE";
///lead/overview/funnel
export const LEAD_OVERVIEW_FUNNEL = "LEAD_OVERVIEW_FUNNEL";
export const LEAD_OVERVIEW_FUNNEL_SUCCESS = "LEAD_OVERVIEW_FUNNEL_SUCCESS";
export const LEAD_OVERVIEW_FUNNEL_FAILURE = "LEAD_OVERVIEW_FUNNEL_FAILURE";
///lead/data/
export const LEAD_DATA = "LEAD_DATA";
export const LEAD_DATA_SUCCESS = "LEAD_DATA_SUCCESS";
export const LEAD_DATA_FAILURE = "LEAD_DATA_FAILURE";
///lead/create
export const LEAD_CREATE = "LEAD_CREATE";
export const LEAD_CREATE_SUCCESS = "LEAD_CREATE_SUCCESS";
export const LEAD_CREATE_FAILURE = "LEAD_CREATE_FAILURE";
///lead/update
export const LEAD_UPDATE = "LEAD_UPDATE";
export const LEAD_UPDATE_SUCCESS = "LEAD_UPDATE_SUCCESS";
export const LEAD_UPDATE_FAILURE = "LEAD_UPDATE_FAILURE";
///lead/delete
export const LEAD_DELETE = "LEAD_DELETE";
export const LEAD_DELETE_SUCCESS = "LEAD_DELETE_SUCCESS";
export const LEAD_DELETE_FAILURE = "LEAD_DELETE_FAILURE";
///lead/search
export const LEAD_SEARCH = "LEAD_SEARCH";
export const LEAD_SEARCH_SUCCESS = "LEAD_SEARCH_SUCCESS";
export const LEAD_SEARCH_FAILURE = "LEAD_SEARCH_FAILURE";
///leadtask/search
export const LEAD_TASK_SEARCH = "LEAD_TASK_SEARCH";
export const LEAD_TASK_SEARCH_SUCCESS = "LEAD_TASK_SEARCH_SUCCESS";
export const LEAD_TASK_SEARCH_FAILURE = "LEAD_TASK_SEARCH_FAILURE";
///leadtask/create
export const LEAD_TASK_CREATE = "LEAD_TASK_CREATE";
export const LEAD_TASK_CREATE_SUCCESS = "LEAD_TASK_CREATE_SUCCESS";
export const LEAD_TASK_CREATE_FAILURE = "LEAD_TASK_CREATE_FAILURE";

///leadtasktype/list
export const LEAD_TASK_TYPE_LIST = "LEAD_TASK_TYPE_LIST";
export const LEAD_TASK_TYPE_LIST_SUCCESS = "LEAD_TASK_TYPE_LIST_SUCCESS";
export const LEAD_TASK_TYPE_LIST_FAILURE = "LEAD_TASK_TYPE_LIST_FAILURE";
///leadtasktype/data
export const LEAD_TASK_TYPE_DATA = "LEAD_TASK_TYPE_DATA";
export const LEAD_TASK_TYPE_DATA_SUCCESS = "LEAD_TASK_TYPE_DATA_SUCCESS";
export const LEAD_TASK_TYPE_DATA_FAILURE = "LEAD_TASK_TYPE_DATA_FAILURE";
///leadtasktype/create
export const LEAD_TASK_TYPE_CREATE = "LEAD_TASK_TYPE_CREATE";
export const LEAD_TASK_TYPE_CREATE_SUCCESS = "LEAD_TASK_TYPE_CREATE_SUCCESS";
export const LEAD_TASK_TYPE_CREATE_FAILURE = "LEAD_TASK_TYPE_CREATE_FAILURE";
///leadtasktype/update
export const LEAD_TASK_TYPE_UPDATE = "LEAD_TASK_TYPE_UPDATE";
export const LEAD_TASK_TYPE_UPDATE_SUCCESS = "LEAD_TASK_TYPE_UPDATE_SUCCESS";
export const LEAD_TASK_TYPE_UPDATE_FAILURE = "LEAD_TASK_TYPE_UPDATE_FAILURE";
///leadtasktype/delete
export const LEAD_TASK_TYPE_DELETE = "LEAD_TASK_TYPE_DELETE";
export const LEAD_TASK_TYPE_DELETE_SUCCESS = "LEAD_TASK_TYPE_DELETE_SUCCESS";
export const LEAD_TASK_TYPE_DELETE_FAILURE = "LEAD_TASK_TYPE_DELETE_FAILURE";
///leadrecentactivity/list
export const LEAD_RECENT_ACTIVITY_LIST = "LEAD_RECENT_ACTIVITY_LIST";
export const LEAD_RECENT_ACTIVITY_LIST_SUCCESS = "LEAD_RECENT_ACTIVITY_LIST_SUCCESS";
export const LEAD_RECENT_ACTIVITY_LIST_FAILURE = "LEAD_RECENT_ACTIVITY_LIST_FAILURE";
